import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { EntityService } from '../../entity.service';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent implements OnInit {

  constructor(public matDialogRef: MatDialogRef<AddAddressComponent>, public _addressService: EntityService, @Inject(MAT_DIALOG_DATA) public dialogData: any, private _matDialog: MatDialog) { }
  addressForm: FormGroup;
  @ViewChild('deleteAdrsCnfrmDialog') deleteAdrsCnfrmDialog: TemplateRef<any>;
  ctgryLst = []
  lctnTypsLst = []
  hndlr_nm
  enty_ky
  stetsLst = []
  dstrctsLst = []
  shwGeoLctns: boolean = false
  shwAddrsFrm: boolean = false
  latitude
  longitude
  lctn_type_id
  editData
  hdng_nm
  sve_btn
  loader
  deleteDialog
  ngOnInit(): void {
    this.addressForm = new FormGroup({
      "lctn_type_id": new FormControl(''),
      "adrs_nm": new FormControl(''),
      "ste_id": new FormControl(''),
      "dstrt_id": new FormControl(''),
      "dr_nu": new FormControl(''),
      "adrs1_tx": new FormControl(''),
      "adrs2_tx": new FormControl(''),
      "ctry_nm": new FormControl(''),
      "lat": new FormControl(''),
      "lng": new FormControl('')
    });
    if (this.dialogData) {
      if (this.dialogData.edit_in) {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.editData = this.dialogData.editData;
        this.hdng_nm = 'Edit';
        this.sve_btn = 'Update';
        this.getLctnTyps()
      }
      else {
        this.hndlr_nm = this.dialogData.hndlr_nm;
        this.enty_ky = this.dialogData.enty_ky;
        this.hdng_nm = 'Add';
        this.sve_btn = 'Add';
        this.getLctnTyps()
      }

    }
    else {
      this.hndlr_nm = 'address'
      this.enty_ky = 1
      this.hdng_nm = 'Add';
      this.sve_btn = 'Add';
      this.getLctnTyps()
    }


  }
  Close(): void {
    this.matDialogRef.close();
  }
  send() {

    this.addressForm.value['enty_ky'] = this.enty_ky;
    this.addressForm.value['lctn_type_id'] = this.lctn_type_id;
    this.addressForm.value['hndlr_nm'] = this.hndlr_nm;

    if (this.editData) {
      this.loader = true
      this.addressForm.value['adrs_id'] = this.editData.adrs_id;
      this._addressService.updte_address(this.addressForm.value).subscribe((res) => {
        this.loader = false
        if (res['status'] == 200) {
          this._addressService.openSnackBar(res['message'], 'mat-primary');
          this.addressForm.reset()
          this.matDialogRef.close();
        }
        else {
          this._addressService.openSnackBar(res['message'], 'mat-warn');
        }

      })
    }
    else {
      this.loader = true
      this._addressService.new_address(this.addressForm.value).subscribe((res) => {
        this.loader = false
        if (res['status'] == 200) {
          this._addressService.openSnackBar(res['message'], 'mat-primary');
          this.addressForm.reset()
          this.matDialogRef.close();
        }
        else {
          this._addressService.openSnackBar(res['message'], 'mat-warn');
        }

      })
    }

  }
  onLctnTypChnge(e) {
    this.lctn_type_id = e.lctn_type_id
    if (e.lctn_in == 1 && e.adrs_in == 1) {
      this.shwGeoLctns = true
      this.shwAddrsFrm = true
      this.getStates()
    }
    else if (e.lctn_in == 0 && e.adrs_in == 1) {
      this.shwGeoLctns = false
      this.shwAddrsFrm = true
      this.addressForm.get('lat').setValue('')
      this.addressForm.get('lng').setValue('')
      this.getStates()
    }
    else if (e.lctn_in == 1 && e.adrs_in == 0) {
      this.shwGeoLctns = true
      this.shwAddrsFrm = false
      this.addressForm.get('ste_id').setValue('')
      this.addressForm.get('dstrt_id').setValue('')
      this.addressForm.get('dr_nu').setValue('')
      this.addressForm.get('adrs1_tx').setValue('')
      this.addressForm.get('adrs2_tx').setValue('')
      this.addressForm.get('ctry_nm').setValue('')
    }
  }
  getLctnTyps() {
    this._addressService.get_location_types(this.hndlr_nm).subscribe((res) => {
      if (res['status'] == 200) {
        this.lctnTypsLst = res['data']
        if (this.editData) {
          this.lctn_type_id = this.editData.lctn_type_id
          this.lctnTypsLst.filter((l) => {

            if (l.lctn_type_id == this.editData.lctn_type_id) {
              this.addressForm.get('lctn_type_id').setValue(l)
              if (l.adrs_in == 1 && l.lctn_in == 1) {
                this.shwGeoLctns = true;
                this.shwAddrsFrm = true
                this.getStates()
                this.getDistrcts(this.editData.ste_id)
                this.edtFnc()
              }
              else if (l.adrs_in == 1 && l.lctn_in == 0) {
                this.shwGeoLctns = false;
                this.shwAddrsFrm = true
                this.getStates()
                this.getDistrcts(this.editData.ste_id)
                this.edtFnc()
              }
              if (l.adrs_in == 0 && l.lctn_in == 1) {
                this.shwGeoLctns = true;
                this.shwAddrsFrm = false
                this.edtFnc()
              }
            }
          })
        }
        if (this.lctnTypsLst.length == 1) {
          this.addressForm.get('lctn_type_id').setValue(this.lctnTypsLst[0]);
          this.onLctnTypChnge(this.lctnTypsLst[0])
        }
      }
      else {
        this._addressService.openSnackBar(res['message'], 'amber');
      }
    })
  }
  getStates() {
    this._addressService.get_states().subscribe((res) => {
      if (res['status'] == 200) {
        this.stetsLst = res['data']
        if (this.stetsLst.length == 1) {
          this.addressForm.get('ste_id').setValue(this.stetsLst[0].ste_id)
          this.getDistrcts(this.stetsLst[0].ste_id)
        }
      }
      else {
        this._addressService.openSnackBar(res['message'], 'mat-warn');
      }

    })
  }
  getDistrcts(ste_id) {
    this._addressService.get_districts(ste_id).subscribe((res) => {
      this.dstrctsLst = res['data']
    })
  }
  onSteChnge(e) {
    this.getDistrcts(e.value)
  }
  getLocation() {
    navigator.geolocation.getCurrentPosition(pos => {
      this.addressForm.get('lat').setValue(pos.coords.latitude)
      this.addressForm.get('lng').setValue(pos.coords.longitude)
    })
  }
  edtFnc() {
    this.addressForm.get('ste_id').setValue(this.editData.ste_id)
    this.addressForm.get('dstrt_id').setValue(this.editData.dstrt_id)
    this.addressForm.get('adrs1_tx').setValue(this.editData.adrs1_tx)
    this.addressForm.get('adrs2_tx').setValue(this.editData.adrs2_tx)
    this.addressForm.get('dr_nu').setValue(this.editData.dr_nu)
    this.addressForm.get('ctry_nm').setValue(this.editData.ctry_nm)
    this.addressForm.get('adrs_nm').setValue(this.editData.adrs_nm)
    this.addressForm.get('lat').setValue(this.editData.lat)
    this.addressForm.get('lng').setValue(this.editData.lng)
  }
  delete() {
    this.deleteDialog = this._matDialog.open(this.deleteAdrsCnfrmDialog);
  }
  deleteAdrs() {
    this.deleteDialog.close()
    this.loader = true;
    this._addressService.remove_address(this.editData.adrs_id).subscribe((res) => {
      this.loader = false
      if (res['status'] == 200) {
        this.matDialogRef.close();
        this._addressService.openSnackBar(res['message'], 'mat-primary');
      }
      else {
        this._addressService.openSnackBar(res['message'], 'mat-warn');
      }
    })
  }
  closeDialog() {
    this.deleteDialog.close()
  }
}
